import React, { useState } from "react";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import { useNavigate } from "react-router-dom";
import { getApi } from '../../api/endpoints';
import ListingPageComponent from '../../components/ListingPageComponent';
import UI_ACTIONS from '../../data/UiActionConstants';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import UiAction from '../../components/UiAction';
import FiltersPartial from "./FiltersPartial.js";

const Index = () => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: false };
  const [filtersModel, setFiltersModel] = useState({
    status: ['accepted']
  });

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'nomenclature_id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Circle',
      attr: 'branch_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Firm',
      attr: 'firm_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Wallet Balance',
      attr: 'wallet_balance',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Mobile Number',
      attr: 'mobile_number',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Activated at',
      attr: 'activated_at',
      disableSort: false
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_distributor_list.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onViewClick(row.id)}>
              <FontAwesomeIcon icon={faEye} />
            </div>
          </UiAction>
        </div>
      }
    }
  ]
  
  const onViewClick = (id) => {
    navigate(`/distributors/${id}`)
  }

  return <>
    <ListingPageComponent
      key={PAGES.DistributorsListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.DistributorsListingPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Distributors' }]}
      listingMutation={getApi('chargingPartners')}
      className="charging-partners-listing-page"
      contentHeading="Distributors List - Results"
      headers={headers}
      recordsKey="charging_partners"
      filtersModel={filtersModel}
      filters={
        <FiltersPartial
          filtersModel={filtersModel}
          setFiltersModel={setFiltersModel}
        />
      }
      searchBy={['ID', 'Name', 'Firm', 'Mobile Number']}
    />
  </>
};

export default Index;
